import {
  aRuleValidationResult,
  mockTemplatedMatchRuleValidationResultOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const templatedMatchRuleValidationResultOperation = {
  __typename: 'Query' as const,
  templatedMatchRuleValidationResult: aRuleValidationResult({
    isValid: true,
  }),
};

export const handlers = [
  mockTemplatedMatchRuleValidationResultOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: templatedMatchRuleValidationResultOperation,
      });
    }
  ),
];
